import React from 'react';

interface ColorProps {
  children: React.ReactNode;
  value?: any;
}

const Color = ({ children, value }: ColorProps) => {  
    
  return (
    <span
      style={{
        color: value?.hex ?? undefined,
      }}
    >
      {children}
    </span>
  );
};

export default Color;
